export default "__VITE_ASSET__D7sIbK_f__"